// extracted by mini-css-extract-plugin
export default {"display-none":"display-none","display-block":"display-block","bg-none":"bg-none","bg-jd":"bg-jd"};